module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="filter-popup__input">\n	<input type="text" class="form-control js-text-value" name="" placeholder="" value="'+
((__t=( getValue() ))==null?'':__t)+
'">\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/devices-filter/templates/filter-text.html
// module id = 404
// module chunks = 0